import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

const GoogleLoginButton = ({ onSuccess, onError }) => {
  const handleSuccess = (credentialResponse) => {
    if (credentialResponse?.credential) {
      onSuccess(credentialResponse.credential);
      return;
    }
    onError('Token do Google inválido.');
  };

  const handleError = () => {
    onError('Falha ao autenticar com Google.');
  };

  return (
    <GoogleLogin onSuccess={handleSuccess} onError={handleError} />
  );
};

export default GoogleLoginButton;
